import { Phone, MessageCircle, FileText } from "lucide-react";
import { COMPANY, wa, WA_MESSAGES } from "@/data/site";
import { useQuote } from "@/components/QuoteModal";
import { track } from "@/lib/analytics";

export const MobileActionBar = () => {
  const { openQuote } = useQuote();
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden grid grid-cols-3 border-t border-cts-line shadow-[0_-8px_24px_-12px_rgba(23,27,30,0.35)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={COMPANY.phoneHref}
        onClick={() => track("phone_click", { location: "mobile_bar" })}
        data-testid="mobile-bar-call-btn"
        className="flex items-center justify-center gap-2 bg-cts-charcoal text-white font-heading font-bold text-sm min-h-[56px]"
      >
        <Phone size={18} /> CALL
      </a>
      <a
        href={wa(WA_MESSAGES.general)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track("whatsapp_click", { location: "mobile_bar" })}
        data-testid="mobile-bar-whatsapp-btn"
        className="flex items-center justify-center gap-2 text-white font-heading font-bold text-sm min-h-[56px]"
        style={{ backgroundColor: "#25D366" }}
      >
        <MessageCircle size={18} /> WHATSAPP
      </a>
      <button
        onClick={() => openQuote()}
        data-testid="mobile-bar-quote-btn"
        className="flex items-center justify-center gap-2 bg-cts-red text-white font-heading font-bold text-[12px] min-h-[56px]"
      >
        <FileText size={17} /> GET A QUOTE
      </button>
    </div>
  );
};
